export interface BudgetItem {
  id: number;
  category: string;
  amount: number;
  type: 'income' | 'expense';
}

export interface BudgetGameState {
  items: BudgetItem[];
  totalIncome: number;
  totalExpenses: number;
  balance: number;
  timeLeft: number;
  isGameOver: boolean;
  gameStarted: boolean;
  score: number;
  cerebrixEarned?: number;
  stats: {
    categoriesUsed: string[];
    totalCategories: number;
    isBalanced: boolean;
    hasSavings: boolean;
    errorCount: number;
    categoryCoverage?: number;
    startTime?: number;
  };
}

// Categorías predefinidas para el juego
export const BUDGET_CATEGORIES: Record<string, string[]> = {
  income: [
    'Salario',
    'Mesada',
    'Regalo',
    'Premio',
    'Venta',
    'Otros Ingresos'
  ],
  expense: [
    'Ahorro',
    'Comida',
    'Transporte',
    'Diversión',
    'Educación',
    'Otros Gastos'
  ]
};

// Iconos para las categorías
export const CATEGORY_ICONS: Record<string, string> = {
  'Salario': '💰',
  'Mesada': '🎁',
  'Regalo': '🎀',
  'Premio': '🏆',
  'Venta': '🛍️',
  'Otros Ingresos': '💵',
  'Ahorro': '🏦',
  'Comida': '🍎',
  'Transporte': '🚌',
  'Diversión': '🎮',
  'Educación': '📚',
  'Otros Gastos': '📝'
};

// Consejos financieros para niños
export const BUDGET_TIPS = [
  "Siempre guarda una parte de tu dinero para ahorrar",
  "Antes de gastar, piensa si realmente necesitas lo que vas a comprar",
  "Haz una lista de lo que quieres comprar y ordénala por importancia",
  "Compara precios antes de comprar algo",
  "Aprende a diferenciar entre lo que necesitas y lo que deseas",
  "Establece metas de ahorro para cosas importantes",
  "No gastes todo tu dinero apenas lo recibes"
];

export const INITIAL_STATE: BudgetGameState = {
  items: [],
  totalIncome: 0,
  totalExpenses: 0,
  balance: 0,
  timeLeft: 300, // 5 minutos
  isGameOver: false,
  gameStarted: false,
  score: 0,
  stats: {
    categoriesUsed: [],
    totalCategories: Object.values(BUDGET_CATEGORIES).flat().length,
    isBalanced: false,
    hasSavings: false,
    errorCount: 0
  }
};
